// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ColorFieldController from "./color_field_controller"
application.register("color-field", ColorFieldController)

import DeckPreviewController from "./deck_preview_controller"
application.register("deck-preview", DeckPreviewController)

import GameCardController from "./game_card_controller"
application.register("game-card", GameCardController)

import HtmlPreviewController from "./html_preview_controller"
application.register("html-preview", HtmlPreviewController)

import ImageLibraryController from "./image_library_controller"
application.register("image-library", ImageLibraryController)

import ImagePickerController from "./image_picker_controller"
application.register("image-picker", ImagePickerController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)
